<template>
  <v-modal id="modal-filters">
    <span slot="header">
      {{ i18nJS.print_requirements }}
    </span>
    <div>
      <!-- <div v-for="(requirement, index) in filters" v-bind:key="index">
        <component :is="requirement.model+'-requirement'" :key="requirement.name + index"
                   :buId = "3" :requirement = requirement :index= index
                   @selected="filterSelected($event, index)" style="margin-bottom: 10px"></component>
      </div> -->
      <div v-for="(filter, index) in filtersComponents" :key="index">
        <component :is="filter" @selected="(sel) => filterSelected(sel)" />
        <br />
      </div>
    </div>
    <div style="display: flex" v-if="loading">{{ i18nJS.printing }}<spinner></spinner></div>
    <printlink
      :eventOnPrint="'closeModal'"
      slot="footer"
      :href="'/it/reports/generate_report.json'"
      :use_print_service="true"
      :params="{ data: data, type: type, worker: worker }"
    >
      <span class="btn btn-success">
        {{ i18nJS.command.print }}
      </span>
    </printlink>
  </v-modal>
</template>

<script>
import vModal from './vModal';
import apiConnector from '@/epersonam/apiConnector';
import userRequirement from './print/models/userRequirement';
import guestRequirement from './print/models/guestRequirement';
import dateRequirement from './print/models/dateRequirement';
import startEndDateFilter from './print/filters/startEndDateFilter';
import dismissedFilter from './print/filters/dismissedFilter';
import unitsSelectorFilter from './print/filters/unitsSelectorFilter';
import monthYearFilter from './print/filters/monthYearFilter';
import spinner from './spinner';
import { GenericFilter } from './models/genericFilter';
import Vue from 'vue';
import printlink from './printlink';

export default {
  name: 'genericFiltersModal',
  props: [],
  data() {
    return {
      genericFilter: new GenericFilter(),
      filtersComponents: [],
      url: null,
      loading: false,
      filtesParams: {},
      data: {},
      type: null,
      worker: null,
    };
  },
  components: {
    vModal,
    userRequirement,
    guestRequirement,
    spinner,
    dateRequirement,
    printlink,
    startEndDateFilter,
    dismissedFilter,
    unitsSelectorFilter,
    monthYearFilter,
  },
  mounted() {
    eventBus.$on('closeModal', this.closeModal);
    eventBus.$on('openGenericFiltersModal', (result) => {
      this.type = result.params.type;
      this.worker = result.params.worker;
      this.data = result.params.data;
      this.filtersComponents = result.filters;
      this.data_input = { ...result.params.data };
      $('#modal-filters').modal('show');
    });
    $('#modal-filters').on('hidden', () => {
      this.filtersComponents = [];
    });
  },
  computed: {
    i18nJS() {
      return window.i18nJS;
    },
  },
  methods: {
    closeModal() {
      $('#modal-filters').modal('hide');
    },
    filterSelected(selected, index) {
      this.genericFilter.setParams(selected.data_selected);
      this.data.url = this.genericFilter.toGetParamsString(this.data_input.url);
    },
  },
};
</script>

<style lang="scss" scoped></style>
